import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'projectAdBudgets',
  urlRoot: '/project_ad_budgets',
  getters: {
    byProject: (state) => (id) => {
      return Object.values(state.entities).filter(projectAdBudget => projectAdBudget.project === '/projects/' + id)
    },
    amountByProject: (state, getters) => id => {
      return getters.byProject(id)
        .filter(projectAdBudget => projectAdBudget.amount)
        .map(projectAdBudget => parseFloat(projectAdBudget.amount))
        .reduce((cur, acc) => cur + acc, 0)
    }
  }
})
